export default function injectMobileBanner() {
    try {
        let mainContainer = document.querySelector('#main-container');
        let mobileBanner = document.createElement('div');
        mobileBanner.id = 'mobile-banner';
        mobileBanner.innerHTML = '<p>We recommend that you complete your courses on a desktop computer.</p>';
        let closeBtn = document.createElement('div');
        closeBtn.id = 'close-btn';
        closeBtn.addEventListener('click', () => {
            mobileBanner.classList.add('closed');
        });
        mobileBanner.appendChild(closeBtn);
        mainContainer.appendChild(mobileBanner);
    } catch (error) {
        console.error("Error loading mobile banner.", error);
    }
}
